// Aarohi Luxe storefront navigation — single source for header, mobile drawer and footer.

export const SHOP_CATEGORIES = [
  { label: 'Sarees', href: '/products?category=sarees', note: 'Banarasi · Kanjivaram · Paithani' },
  { label: 'Lehengas', href: '/products?category=lehengas', note: 'Bridal · Sangeet · Festive' },
  { label: 'Salwar Suits', href: '/products?category=salwar-suits', note: 'Chikankari · Sharara · Silk' },
  { label: 'Anarkali Sets', href: '/products?category=anarkali', note: 'Floor-length flares' },
  { label: 'Kurtas & Kurtis', href: '/products?category=kurtas', note: 'Block prints · Chikankari' },
  { label: 'Indo-Western', href: '/products?category=indo-western', note: 'Cape gowns · Dhoti sets' },
  { label: 'Dupattas', href: '/products?category=dupattas', note: 'Banarasi · Phulkari' },
] as const;

export const SHOP_OCCASIONS = [
  { label: 'Wedding', href: '/products?occasion=wedding' },
  { label: 'Sangeet', href: '/products?occasion=sangeet' },
  { label: 'Haldi & Mehendi', href: '/products?occasion=haldi-mehendi' },
  { label: 'Festive', href: '/products?occasion=festive' },
  { label: 'Party & Reception', href: '/products?occasion=party' },
  { label: 'Everyday', href: '/products?occasion=everyday' },
] as const;

export const PRIMARY_NAV = [
  { label: 'New In', href: '/products?sort=new', accent: true },
  { label: 'Sarees', href: '/products?category=sarees' },
  { label: 'Lehengas', href: '/products?category=lehengas' },
  { label: 'Suits', href: '/products?category=salwar-suits' },
  { label: 'Anarkalis', href: '/products?category=anarkali' },
  { label: 'Kurtas', href: '/products?category=kurtas' },
] as const;

export const POPULAR_SEARCHES = ['Banarasi silk', 'Bridal lehenga', 'Chikankari', 'Anarkali', 'Organza saree'] as const;

export const HELP_LINKS = [
  { label: 'Contact us', href: '/contact' },
  { label: 'FAQ', href: '/faq' },
  { label: 'Track your order', href: '/track-order' },
  { label: 'Shipping & returns', href: '/faq' },
] as const;

export const ABOUT_LINKS = [
  { label: 'Our story', href: '/about' },
  { label: 'Privacy policy', href: '/privacy' },
  { label: 'Terms of service', href: '/terms' },
] as const;

export const ANNOUNCEMENTS = [
  'Complimentary US shipping on orders over $250',
  'Handcrafted by artisans across India',
  'Easy 30-day returns on unworn pieces',
] as const;

/** Portal areas have their own navigation; storefront extras are hidden there. */
export const PORTAL_PREFIXES = ['/admin', '/super-admin', '/vendor', '/dealer', '/installer', '/sales'] as const;
export const isPortalPath = (pathname: string | null) =>
  !!pathname && PORTAL_PREFIXES.some((p) => pathname === p || pathname.startsWith(`${p}/`));
